<template>
    <div id="s-langueSelector">

<!--<b-row class="justify-content-center">-->
        <h6 class="subTitle3">{{$t('g_LangueEmploye')}}</h6>
        <b-row>
            <b-form-group class="MargeLeft15 txtMain">
            <b-form-radio v-model="_value" :size="chkSize" name="fr" value="1">{{$t('g_Francais')}}</b-form-radio>
            <b-form-radio v-model="_value" :size="chkSize" name="en" value="2">{{$t('g_Anglais')}}</b-form-radio>
            </b-form-group>
        </b-row>
    
    </div>
    
</template>

<script>
import {mapGetters} from 'vuex'


export default{
    name: 's-langueSelector',
    props: ['value'],
    data() {
        return {
            chkSize: this.$store.getters.getCheckSize,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme', 'getCheckSize']),
        _value: {
            get: function() {return this.value},
            set: function(modifiedValue){this.$emit('update:value', modifiedValue)}
        }

    },
    watch: {
  
    }    
}
</script>

<style lang="scss" scoped>

</style>